import { render, staticRenderFns } from "./InscriptionIndicators.vue?vue&type=template&id=36d84f47&scoped=true&"
import script from "./InscriptionIndicators.vue?vue&type=script&lang=js&"
export * from "./InscriptionIndicators.vue?vue&type=script&lang=js&"
import style0 from "./InscriptionIndicators.vue?vue&type=style&index=0&id=36d84f47&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d84f47",
  null
  
)

export default component.exports